module.exports = __webpack_public_path__ + "static/media/passo-4.7fecd3bb.png";